// extracted by mini-css-extract-plugin
export default {"row":"f8exmyMvN9SYBaFnMB4rXA== body-2","label":"Ap4758Kh69TY2nnfE19tgA==","danger":"cIjxt0u3Joi9LcUkhYgpSQ==","content":"ZgFz16HROm+nfUwGiw8h3A=="};